<template>
    <div class="preview-page"
         :style="{height:(activeType==1?'100vh':'auto')}">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class='herder'>
                <span class='back'
                      @click="clickBack"><i></i></span>
                <p>查看完成情况</p>
            </div>
            <div class="main">
                <div class="tab"
                     :class="activeType==1?'left':'right'">
                    <span @click="viewType(1)"
                          :class="activeType==1?'font-bold':''">按学生查看</span>
                    <span @click="viewType(2)"
                          :class="activeType==2?'font-bold':''">按作业查看</span>
                </div>
                <div class="stu-view"
                     v-show="activeType==1&&stu_data.length">
                    <div class="scroll-box">
                        <div class="item"
                             v-for="(item,index) in stu_data"
                             :key="index">
                            <div class="stu-info">
                                <img :src="item.portrait">
                                <span>{{item.real_name}}</span>
                            </div>
                            <div class="done-info">
                                <p>复习巩固完成数量 <span>{{item.user_review_len+'/'+item.review_paper_len}}</span></p>
                                <p>新课预习完成数量 <span>{{item.user_preview_len+'/'+item.preview_paper_len}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="homework-view"
                     v-show="activeType==2">
                    <div class="item">
                        <div class="title">{{unit_name}} {{sid==21?'数学':'语文'}}复习巩固</div>
                        <ul class="clearfix"
                            v-if="review_paper.length">
                            <li v-for="(item,index) in review_paper"
                                @click="goDetail(item)"
                                :key="index">
                                <span class="paper-name">{{item.name}}</span>
                                <span class="done-info">{{item.stu_len}}/{{item.unit_len}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="item">
                        <div class="title">{{unit_name}} {{sid==21?'数学':'语文'}}新课预习</div>
                        <ul class="clearfix"
                            v-if="preview_paper.length">
                            <li v-for="(item,index) in preview_paper"
                                @click="goLessonPreview(item)"
                                :key="index">
                                <span class="paper-name">{{item.name}}</span>
                                <span class="done-info">{{item.stu_len}}/{{item.unit_len}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="share"
                 v-if="activeType==1">
                <span @click="share">分享班级完成情况</span>
            </div>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
export default {
    components: {
        loadings
    },
    data () {
        return {
            loading: false,
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            //当前选中的类型
            activeType: this.$store.state.winter2022.tabtype,
            //sid
            sid: this.$route.params.sid,
            //unit_class_id
            unit_class_id: this.$route.params.unit_class_id,
            //按学生查看
            stu_data: [],
            //按作业查看
            preview_paper: '',//新课预习
            review_paper: '',//复习巩固
            //班级名称
            unit_name: ''
        }
    },
    created () {
        this.getInfoData(1)
        this.getInfoData(2)
    },
    methods: {
        clickBack () {
            this.$router.go(-1);
        },
        //tab切换
        viewType (e) {
            this.activeType = e
            this.$store.commit('set2022WinterTabtype', e)
        },
        //获取数据
        getInfoData (activeType) {
            let str = activeType == 1 ? 'stu_complete_list' : 'paper_complete_list'
            let url = API_URL_HD_API + '/winter2023/tea/' + str
            let params = {
                sid: this.sid,
                unit_class_id: this.unit_class_id
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response === 'ok') {
                    if (activeType == 1) {
                        this.stu_data = res.data.data.stu_data
                    }
                    if (activeType == 2) {
                        //新课预习
                        this.preview_paper = res.data.data.paper_data.preview_paper
                        //复习巩固
                        this.review_paper = res.data.data.paper_data.review_paper
                        //班级名称
                        this.unit_name = res.data.data.unit_name
                    }
                }
            })
        },
        //分享班级完成情况
        share () {
            let that = this
            let url = `${VUE_URL_HD}/#/activity/2023winter/finishdetail/${this.sid}/${this.unit_class_id}`;
            if (this.inApp) {
                let title = `${this.unit_name}完成情况`;
                let content = `点击查看${this.sid == 21 ? '数学' : '语文'}寒假作业完成情况`;
                this.appFunction("ys_share", `${title},${content},${url},${this.sid},${this.unit_class_id},0,26,寒假作业活动分享`);

            } else {
                this.$http.post(API_URL_SORT_API + '/create_sort/', {
                    url: url,
                    sort_type: 1
                }).then((res) => {
                    if (res.data.response === 'ok') {
                        let content = `${this.unit_name}完成情况，点击链接查看${this.sid == 21 ? '数学' : '语文'}寒假作业完成情况，链接：${res.data.data.short_url}`
                        layer.alert('在输入框中进行粘贴后，点击发送即可！', 'tea', function (index) {
                            that.copyText(content)
                            layer.close(index)
                        }, '分享链接复制成功')
                    }
                })
            }

        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        //查看详情-按学生
        goDetail (item) {
            this.$router.push(`/personaLearning?sid=${this.sid}&taskId=${item.paper_id}&taskType=2023winter&classId=${this.unit_class_id}&className=${this.unit_name}`)
        },
        //新课预习
        goLessonPreview (item) {
            this.$router.push(`/activity/2023winter/viewLessonDetail/${this.sid}/${this.unit_class_id}/${item.paper_id}`)
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-page {
    background: #9c0300;
    min-height: 100vh;
}
.herder {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    background: #ffffff;
    .back {
        width: 64px / $ppr;
        height: 96px / $ppr;
        display: inline-block;
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        z-index: 3;
        i {
            width: 16px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon_img_23.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    p {
        width: 100%;
        text-align: center;
        height: 90px / $ppr;
        display: inline-block;
        font-size: 36px / $ppr;
        color: #333333;
    }
}
.main {
    padding-bottom: 40px / $ppr;
    //tab样式
    .tab {
        text-align: center;
        width: 488px / $ppr;
        margin: 50px / $ppr auto 43px / $ppr;
        background: #eb0000;
        border-radius: 72px / $ppr;
        position: relative;
        span {
            display: inline-block;
            color: #ffe2b7;
            padding: 0 45px / $ppr;
            font-size: 30px / $ppr;
            line-height: 72px / $ppr;
            position: relative;
        }

        &:before {
            content: "";
            position: absolute;
            top: 0;
            width: 50%;
            height: 100%;
            border: 2px / $ppr solid #faf1aa;
            border-radius: 72px / $ppr;
            box-sizing: border-box;
            background-color: #fed678;
            background: linear-gradient(
                #fed678 0%,
                #f7c15b 50%,
                #fed678 100%
            );
        }
    }
    .tab.left {
        &:before {
            left: 0;
        }
        span {
            &:first-child {
                color: #a90514;
            }
        }
    }
    .tab.right {
        &:before {
            right: 0;
        }
        span {
            &:last-child {
                color: #a90514;
            }
        }
    }
}
//按学生查看
.stu-view {
    background: url("./img/unit_center.png") repeat-y;
    background-size: 100% 100%;
    padding: 28px / $ppr 35px / $ppr;
    color: #ffe2b7;
    position: relative;
    margin: 0 24px / $ppr;
    height: calc(100vh - 12rem);
    &:before,
    &:after {
        content: "";
        display: block;
        width: 100%;
        height: 60px / $ppr;
        position: absolute;
        left: 0;
        z-index: 1;
    }
    &:before {
        content: "";
        background: #9c0300 url("./img/unit_top.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
    }
    &:after {
        content: "";
        background: #9c0300 url("./img/unit_bottom.png") no-repeat;
        background-size: 100% 100%;
        bottom: 0;
    }
    .scroll-box {
        max-height: calc(100vh - 12rem);
        overflow-y: scroll;
        position: relative;
        z-index: 8;

        .item {
            border-top: 1px solid #ff8377;
            padding: 30px / $ppr 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            &:first-child {
                border-top: 0;
            }
            .stu-info {
                display: flex;
                align-items: center;
                img {
                    width: 56px / $ppr;
                    height: 56px / $ppr;
                    border-radius: 56px / $ppr;
                    margin-right: 24px / $ppr;
                }
                span {
                    font-size: 28px / $ppr;
                    color: #ffe2b7;
                }
            }
            .done-info {
                p {
                    font-size: 28px / $ppr;
                    color: #ffe2b7;
                    font-weight: lighter;
                    padding: 6px / $ppr 0;
                    span {
                        font-weight: bold;
                        display: inline-block;
                        margin-left: 10px / $ppr;
                    }
                }
            }
        }
    }
}
//按作业查看
.homework-view {
    margin: 0 24px / $ppr;
    .item {
        background: url("./img/unit_center.png") repeat-y;
        background-size: 100% 100%;
        padding: 43px / $ppr 22px / $ppr;
        color: #ffe2b7;
        position: relative;
        margin-bottom: 40px / $ppr;
        &:before,
        &:after {
            content: "";
            display: block;
            width: 100%;
            height: 60px / $ppr;
            position: absolute;
            left: 0;
        }
        &:before {
            content: "";
            background: #9c0300 url("./img/unit_top.png") no-repeat;
            background-size: 100% 100%;
            top: 0;
        }
        &:after {
            content: "";
            background: #9c0300 url("./img/unit_bottom.png") no-repeat;
            background-size: 100% 100%;
            bottom: 0;
        }
        .title {
            width: 596px / $ppr;
            margin: 0 auto 50px / $ppr;
            padding: 17px / $ppr 0;
            background: url("./img/unit-bg.png") repeat-y;
            background-size: 100% 100%;
            font-size: 30px / $ppr;
            color: #a90514;
            text-align: center;
            font-family: 宋体;
            font-weight: 900;
            position: relative;
        }
        ul {
            position: relative;
            z-index: 2;
            margin-left: -7.833333%;
            li {
                width: 25.5%;
                margin-left: 7.833333%;
                margin-bottom: 40px / $ppr;
                float: left;
                position: relative;
                background: #ffba7e;
                border-radius: 10px / $ppr;
                padding: 6px / $ppr;
                box-sizing: border-box;
                .paper-name {
                    display: block;
                    background: #ffe7c2;
                    font-size: 30px / $ppr;
                    color: #f21500;
                    text-align: center;
                    line-height: 84px / $ppr;
                }
                &:before,
                &:after,
                & > .paper-name:before,
                & > .paper-name:after {
                    content: "";
                    display: block;
                    width: 15px / $ppr;
                    height: 15px / $ppr;
                    background: #ffba7e;
                    border-radius: 15px / $ppr;
                    position: absolute;
                }
                &:before {
                    top: 0;
                    left: 0;
                }
                &:after {
                    top: 0;
                    right: 0;
                }
                & > .paper-name:before {
                    bottom: 0;
                    left: 0;
                }
                & > .paper-name:after {
                    bottom: 0;
                    right: 0;
                }
                .done-info {
                    position: absolute;
                    right: -10px / $ppr;
                    top: -10px / $ppr;
                    display: block;
                    background: #11ca8e;
                    color: #fff;
                    font-size: 22px / $ppr;
                    border-radius: 10px / $ppr;
                    line-height: 32px / $ppr;
                    padding: 0 12px / $ppr;
                    z-index: 3;
                }
            }
        }
    }
}

.share {
    position: fixed;
    z-index: 9;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    padding: 20px / $ppr 32px / $ppr;
    box-sizing: border-box;
    span {
        background: #eb0000;
        color: #fff;
        display: block;
        text-align: center;
        font-size: 30px / $ppr;
        border-radius: 40px / $ppr;
        line-height: 80px / $ppr;
    }
}
.font-bold {
    font-weight: bold;
}
</style>